import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Section from '../components/Section';
import { API, store } from '../api';

/**
 * SPA landing for the native-client "auto sign-in" flow. Cap / Windows call
 * POST /user/web-handoff (they already hold a bearer), get back a URL like
 * https://vpnee.tnidu.com/account/sso?h=<handoff>&next=/payments?plan=…
 * We consume the handoff via /session/sso-exchange, drop token+user into
 * localStorage, then bounce to `next`. Handoff is single-use and 5-min TTL,
 * so a leaked URL can't be replayed after landing.
 */
export default function AccountSso() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [msg, setMsg] = useState('Signing you in from your device…');

  useEffect(() => {
    const handoff = params.get('h') || '';
    let next = params.get('next') || '/account';
    if (!next.startsWith('/')) next = '/account';
    if (!handoff) { setMsg('Missing sign-in handoff.'); return; }
    (async () => {
      const r = await API.exchangeSso(handoff);
      if (!r.success) { setMsg(r.message || 'Sign-in link expired or already used.'); return; }
      try {
        store.set('vpnee_token', r.data.token);
        store.set('vpnee_user', JSON.stringify(r.data.user || {}));
      } catch {}
      nav(next, { replace: true });
    })();
  }, [params, nav]);

  return (
    <Section chip="Account" title={msg} subtitle="Establishing your web session from the app.">
      <div className="mx-auto w-16 h-16 rounded-full border-4 border-[color:var(--color-brand)]/25 border-t-[color:var(--color-brand)] animate-spin" />
    </Section>
  );
}
